<template>
  <!-- <b-modal ref="modal" title="SCAN Form" size="xlg" @ok.prevent="onSubmit()" :ok-disabled="!canSubmit"> -->
  <b-modal modal-class="scanForm" ref="modal" title="SCAN Form" size="xlg" no-close-on-backdrop>
    <LoadingSpinner v-if="isLoading"/>

    <p class="mt-3">
      SCAN form stands for "Shipment Confirmation Acceptance Notice"; it is a single page that includes a master barcode that represents all the shipments you will be handing off to USPS.
      When the barcode is scanned, all the shipment information will be uploaded into USPS tracking system and will receive an "Acceptance" event.
    </p>
    <p>

      If you see a package below that is not ready to be handed off, please uncheck and simply proceed.
    </p>

    <b-form-group label-cols="2" label="Postmark Date on Label" >
      <b-select :options="dateOptions" v-model="pickup_date" @change="fetchOrders"></b-select>
    </b-form-group>

    <b-form-group label-cols="2" label="Origin Address" v-if="origins.length">
      <select
        :disabled="!origins.length"
        v-model="selected_origin"
        class="form-control"
        @change="fetchOrders"
      >
        <option
          v-for="origin in origins"
          :key="origin.id"
          :value="origin"
        >
          <span v-if="origin.company">
            {{ origin.company }}
            <span
              v-if="origin.first_name || origin.last_name"
            >,</span>
          </span>
          {{ origin.first_name }} {{ origin.last_name }}, {{ origin.address }}, {{ origin.city }}, {{ origin.state }}
        </option>
      </select>
    </b-form-group>

    <v-client-table :columns="columns" :data="tableData" :options="options">
      <div slot="order_number" slot-scope="props">
        <b-form-checkbox :checked="selected[props.row.order.id]" @change="onOrderSelect(props.row.order.id,!selected[props.row.order.id] )"></b-form-checkbox>
        {{props.row.order_number}}
      </div>

      <div
        slot="recipient"
        slot-scope="props"
        v-html="formatRecipient(props.row.recipient)"
      ></div>
      <div slot="rate" slot-scope="props">{{formatters.price(props.row.rate) }}</div>
      <div slot="created_at" slot-scope="props">{{ props.row.created_at|utcDate("MMM DD YYYY") }}</div>
    </v-client-table>

    <!-- FOOTER -->
    <template slot="modal-footer">
      <div class="w-100">
        <div class="float-left">
          <b-form inline>
            <b-form-select size="sm" v-model="selected_reprint" :options="scanformOptions()"></b-form-select>
            &nbsp;
            <b-btn class="btn-light-blue-outline border" :disabled="!selected_reprint" @click="rePrint">
              Reprint Selected Date
            </b-btn>
          </b-form>
        </div>
        <div class="float-right">
          <b-btn class="btn-new btn-light-blue-outline mr-2" size="sm" variant="secondary" @click="hide()">
            Cancel
          </b-btn>
          <b-btn class="btn-new btn-blue w-auto" size="sm" variant="primary" @click="onSubmit()" :disabled="!canSubmit">
            Print New Scan Form
          </b-btn>
        </div>
      </div>
    </template>

  </b-modal>
</template>

<style lang="scss">
.scanForm {
  select, input {
    font-size: 12px !important;
    height: 21px;
    padding: 0 5px;
  }
}

.VueTables__limit-field {
  display: none !important;
}
</style>

<style lang="scss" scoped>
.VueTables__search__input{
  background-color: white;
}
</style>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

export default {
  props:["scanforms"],
  data() {
    return {
      columns: [
        "order_number",
        "recipient",
        "created_at",
        "service",
        "rate",
        "tracking_id"
      ],
      options: {
        headings: {
          order_number: "Order #",
          created_at: "Shipment Date",
          tracking_id: "Tracking #"
        },
        texts: {
          filterPlaceholder: 'Search Shipment'
        },
        perPage: 100,
      },
      orders: [],
      selected: {},
      isLoading: false,
      origins: [],
      selected_origin: null,
      pickup_date: null,
      selected_reprint: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee_name: "getEmployeeName",
    }),
    tableData() {
      return _.map(this.orders, order => {
        return {
          order: order,
          order_number: order.order_number,
          recipient: order.shipping_address,
          created_at: order.future_shipping ? order.future_shipping_date : order.label.created_at,
          service: order.shipping_service.name,
          rate: order.rate,
          tracking_id: order.label.tracking_id
        };
      });
    },
    dateOptions() {
      if(!this.selected_origin) return []

      let date = moment.tz(this.selected_origin.timezone)
      if(date.hour() >= 20) {
        date.add(1, 'day')
      }

      let options = []
      for(let i = 0; i <= 7; i++) {
        options.push({
          text: date.format('dddd, MMMM Do YYYY'),
          value: date.format('YYYY-MM-DD')
        })

        date.add(1, 'day')
      }

      return options
    },
    canSubmit() {
      return !_.isEmpty(this.selected_origin) && this.pickup_date && Object.keys(this.selected).length;
    }
  },
  created() {
    this.$on("show", async () => {
      await this.fetchOrigins()
      let date = moment.tz(this.selected_origin.timezone)
      if(date.hour() >= 20) {
        date.add(1, 'day')
      }
      this.pickup_date = date.format('YYYY-MM-DD')
      await this.fetchOrders()
    });
  },
  methods: {
    ...mapActions(['addPrintJob']),
    show() {
      this.$refs.modal.show();
      this.$emit("show");
    },
    hide() {
      this.selected = {};
      this.$refs.modal.hide();
      this.$emit("hide");
    },
    async fetchOrigins() {
      let response = await axios.get("user/addresses");

      this.origins = response.data;
      if (this.origins.length > 0) {
        let selected = _.find(response.data, addr => addr.is_default);

        if (this.employee_name) {
          const employee = this.user.employees.find(e => e.name === this.employee_name)
          if (employee && employee.origin_id) {
            selected = _.find(response.data, addr => addr.id === employee.origin_id)
          }
        }

        this.selected_origin  = selected ? selected : this.origins[0]
      }
    },
    async fetchOrders() {
      if(!this.selected_origin) {
        return;
      }

      let dateRange = [
        moment
          .tz(this.pickup_date,this.selected_origin.timezone)
          .set({'hour': 20, 'minute': 1, 'second': '0'}).subtract(1, 'days') // yesterday 8:01 pm
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        moment
          .tz(this.pickup_date,this.selected_origin.timezone)
          .set({'hour': 20, 'minute': 0, 'second': '59'}) // today 8:00 pm
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      ];

      // const { data } = await axios.get(
      //   `/orders?status=3&date_range[]=${dateRange[0]}&date_range[]=${
      //     dateRange[1]
      //   }&origin_id=${this.selected_origin.id}&scan_form=1`
      // );
      console.log("PICK UP DATE: ", this.pickup_date);
      console.log("DATE RANGES: ", dateRange);
      const { data } = await axios.get(`/orders/scan-forms?future_date=${this.pickup_date}&date_range[]=${dateRange[0]}&date_range[]=${dateRange[1]}&origin_id=${this.selected_origin.id}`);

      console.log('data', data);
      // Filter out already printed orders
      // or those without tracking IDs
      this.orders = _.filter(data, order => {
        return _.isEmpty(order.label.manifest_id) && !_.isEmpty(order.label.tracking_id);
      });
      this.selected = {};
      _.forEach(this.orders, order => {
        this.selected[order.id] = true;
      });
    },
    scanformOptions(){
      console.log('scanforms from modal', this.scanforms);
      if(this.scanforms){
        const options = this.scanforms.map(v => {
          const d = moment.utc(v.created_at).local().format('ddd, MMM DD YYYY h:m A');
          const labels = v.labels;
          return {
            value: v.id,
            text: `${d} - ${labels} packages`
          }
        });
        return [{value: null, text: "Scan Form History"}, ...options];
      }

      return [{value: null, text: "Scan Form History"}];
    },
    async rePrint(){
      try{
        const { data }= await axios.post('/scan-forms', {
          id: this.selected_reprint
        });
        this.addPrintJob({
          label: data.label,
          label_url: data.label_url,
          type: "pdf"
        });
      } catch(e){
        console.log(e);
      }
    },
    async onOrderSelect(id, val){
      this.selected[id] = val;
      console.log(this.selected);
    },
    async onSubmit() {
      try {
        if(moment(this.selected_origin.local_time).hour() >= 20) {
          const msg = 'Hi Shipper! It is past 6pm local time, the label postmark date will be set for the following business day for SCAN Form regulations.';
          let dialog = await this.$dialog.confirm(msg, {
            view: "pausable"
          });
          dialog.close();
        }

        const selected = _.map(_.keys(this.selected), sel => {
          return this.selected[sel] === true ? parseInt(sel) : null;
        }).filter(v => v !== null );

        if(!selected.length) {
          return;
        }

        axios
          .post("/pb/scan-form", {
            ids: selected,
            pickup_date: this.pickup_date,
            origin_id: this.selected_origin.id,
          })
          .then(response => {
            const decoded = response.data;

            this.addPrintJob({
              label: decoded.label,
              label_url: decoded.label_url,
              type: "pdf"
            });

            this.$toastr.s('Manifest SCAN form created successfully!');
            this.hide();
          })
          .catch(e => {
            this.$toastr.e(this.formatters.errors.fromResponse(e));
          });
      } catch (e) {
        this.$toastr.e('Error! Please contact support.');
        console.log(e);
        return;
      }
    },
    formatRecipient(rec) {
      let name = `${rec.first_name || ''} ${rec.last_name || ''}`
      if(name.trim() && rec.company) name = `${name}, ${rec.company}`;
      else if(!name.trim()) name = rec.company;
      return `${name}<br>` + this.formatters.address.pretty(rec);
    },
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Modals/ScanForm.vue